import { Component } from '@angular/core';
import { AppService } from './app.service';
import { MessageService } from '../shared/message.service';
import { Location } from '@angular/common';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  host: { '(window:keydown)': 'hotkeys($event)' },
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'app';
  get chapters(): any[] {
    return this.appService.getAllTopics();
  }
  constructor(public appService: AppService, public messageService: MessageService, public location: Location) {
   }


  /** get text in right language
  * @param {string} tag - text to load
  */
  get(tag: string): String {
    return this.appService.get(tag);
  }

  /** calls the mathod to save the state */
  save() {
    if (this.appService.isTeachersPlaceVisible()) {
      this.appService.storeConfigTeacher();
    } else {
      this.appService.storeState();
    }
  }

  /** defines the hotkey Ctrl-S to prevent the default and store the correct file */
  hotkeys(event) {
    if (event.keyCode == 83 && event.ctrlKey) {
      event.preventDefault();
      this.save();
    }
  }

  /** closes the given alert */
  closeAlert(alert: any) {
    this.messageService.closeAlert(alert);
  }

  /** routes to the previous location */
  back() {
    console.log(this.location.path() === '');
    this.location.back();
  }

}
